import { wGroupIndicesATGeometry } from 'components/AgentTemplateEditView/menu/geometry';
import WGroup from 'components/general/WGroup';
import Wizard from 'components/general/wizards/Wizard';
import { ActiveBranchContext } from 'providers';
import { useContext } from 'react';
import BodyFrameVectorSegment from './BodyFrameVectorSegment';
import ExternalSurfacesSegment from './ExternalSurfacesSegment';
import FieldsOfViewSegment from './FieldsOfViewSegment';
import ReferenceVectorSegment from './ReferenceVectorSegment';

const GeometryEditBoard = () => {
  const { branch } = useContext(ActiveBranchContext);
  const hasSurfaces = ['Spacecraft'].includes(branch.metamodelType);

  return (
    <WGroup index={wGroupIndicesATGeometry.GEOMETRY}>
      <Wizard>
        <BodyFrameVectorSegment />
        {hasSurfaces && <ExternalSurfacesSegment />}
        <FieldsOfViewSegment />
        <ReferenceVectorSegment />
      </Wizard>
    </WGroup>
  );
};

export default GeometryEditBoard;
